import React, { useEffect } from 'react';

const OrganizationSchema = () => {
  const baseUrl = 'https://cyborgsapient.com';

  useEffect(() => {
    // Remove existing organization schema if any
    const existingSchema = document.querySelector('script[type="application/ld+json"][data-org-schema]');
    if (existingSchema) {
      existingSchema.remove();
    }

    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Cyborg Sapient",
      "url": baseUrl,
      "logo": `${baseUrl}/assets/images/logo.png`,
      "description": "AI & Digital Transformation Solutions - Expert digital marketing, SEO, software development, and automation services to transform your business.",
      "foundingDate": "2020",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-9164752256",
        "contactType": "customer service",
        "email": "contact@cyborgsapient.com",
        "availableLanguage": ["English", "Hindi"]
      },
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Pooja Garden, Kalkere",
          "addressLocality": "Bangalore",
          "addressRegion": "Karnataka",
          "postalCode": "560043",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "7901 4th St N #21879",
          "addressLocality": "St Petersburg",
          "addressRegion": "FL",
          "postalCode": "33702",
          "addressCountry": "US"
        }
      ],
      "sameAs": [
        "https://www.facebook.com/profile.php?id=100085886838636",
        "https://www.instagram.com/cyborgsapient/?fbclid=IwY2xjawPcJgZleHRuA2FlbQIxMQBicmlkETFGT2txbXVmU2lsRFFOeUdXc3J0YwZhcHBfaWQBMAABHjvM6qnAhnal3VpNybubhSH3_UAIGdaO64lamBHJyGVoa1nEu6gzmMTGDaMP_aem_48Tq_gg8_wiFjqdAu_jkQg"
      ],
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Digital Marketing & Software Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Search Engine Optimization (SEO)"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Google Ads Management"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Social Media Marketing"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Software Development"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "UI/UX Design"
            }
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-org-schema', 'true');
    script.textContent = JSON.stringify(organizationSchema);
    document.head.appendChild(script);

    return () => {
      if (existingSchema) {
        existingSchema.remove();
      }
    };
  }, []);

  return null;
};

export default OrganizationSchema;

